import React, { useState } from "react"
import Button from "../Button/Button"
import Dropdown from "../Dropdown/Dropdown"
import TrueTag from "../elements/TrueTag"
import {
  marketOptions,
  getMarketDisplayName,
  findMarketRegionByCode,
  getSubRegionDropdownOptions,
  getAllSubRegionDropdownOptions,
  regionHasSubRegions,
  buildMarketCode,
} from "../CompanyUserInfo/options/marketOptions"
import styles from "./index.module.scss"

const firstOption = {
  id: "All",
  value: "All",
}

export const TagFinderView = ({ tagList, onUpdateTagList }) => {
  const [marketList, setMarketList] = useState(tagList)
  const [regionValue, setRegionValue] = useState({})
  const [subRegionValue, setSubRegionValue] = useState(firstOption)
  const [marketCandidate, setMarketCandidate] = useState("")
  const hasSelectedRegion = Boolean(regionValue?.databaseName)
  const regionSubRegions = hasSelectedRegion
    ? getSubRegionDropdownOptions(regionValue)
    : getAllSubRegionDropdownOptions()
  const showSubRegionFilter =
    !hasSelectedRegion || regionHasSubRegions(regionValue)
  const subRegionOptions = showSubRegionFilter
    ? [firstOption, ...regionSubRegions]
    : []

  const handleSubRegionChange = (_, value) => {
    setSubRegionValue(value)
    if (value.id === firstOption.id) {
      setMarketCandidate(regionValue.databaseName || "")
      return
    }

    const regionCode = regionValue.databaseName || value.regionDatabaseName
    if (!regionValue.databaseName && value.regionDatabaseName) {
      const region = findMarketRegionByCode(value.regionDatabaseName)
      if (region) setRegionValue(region)
    }

    setMarketCandidate(buildMarketCode(regionCode, value.databaseName))
  }

  return (
    <div className={styles.root}>
      <p className={styles.label}>Choose your markets:</p>
      <div className={styles.tagList}>
        {marketList.map((market) => (
          <TrueTag
            classes={styles.tag}
            title={getMarketDisplayName(market)}
            onClick={() => {
              const nextMarketList = marketList.filter(
                (item) => item !== market,
              )
              setMarketList(nextMarketList)
              onUpdateTagList(nextMarketList)
            }}
          />
        ))}
      </div>
      <Dropdown
        name="market_region"
        placeholder="Select Region"
        fieldStyle="black"
        className={styles.dropdown}
        options={marketOptions}
        value={regionValue}
        onChange={(_, value) => {
          setRegionValue(value)
          setSubRegionValue(firstOption)
          setMarketCandidate(value.databaseName)
        }}
      />
      {showSubRegionFilter && (
        <Dropdown
          name="market_subregion"
          fieldStyle="black"
          className={styles.dropdown}
          placeholder={
            hasSelectedRegion && regionValue.databaseName === "CA"
              ? "Select province"
              : "Select country"
          }
          options={subRegionOptions}
          value={subRegionValue}
          onChange={handleSubRegionChange}
        />
      )}
      <Button
        className={styles.btn}
        buttonStyle="outlined"
        disabled={!marketCandidate || marketList.includes(marketCandidate)}
        onClick={() => {
          const nextMarketList = [...marketList, marketCandidate]
          setMarketList(nextMarketList)
          onUpdateTagList(nextMarketList)
        }}
      >
        Add market
      </Button>
    </div>
  )
}
